// extracted by mini-css-extract-plugin
export default {"grid-box-skeleton":"dfc04d","grid-box-skeleton__header":"dbb5db","grid-box-skeleton__fields":"d9a4b7","grid-box-skeleton__field":"dc4274"};